export enum SearchResultTypename {
  Company = "Company",
  Contact = "Contact",
  Request = "Request",
}
